@if(loader){
<app-loader></app-loader>
}
<p-card [header]="(iseditProduct===true)?'Update Product':'Create Product'">
    <form [formGroup]="createProductForm">

        <div class="col">

            <div class="field text-left">
                <div class="field col-12 flex justify-content-between align-items-center">
                    <div class="flex">
                        <div>
                            @if(iseditProduct){
                            <p-button label="Update" severity="info" (click)="updateProduct()"
                                icon="pi pi-arrow-circle-up" size="small"></p-button>
                            }@else {
                            <p-button label="Save" icon="pi pi-save" size="small" (click)="createProduct()"></p-button>
                            <p-button label="Reset" (click)="resetForm()" class="p-button-outlined ml-2"
                                icon="pi pi-replay" severity="info" size="small" [disabled]="resetClicked"></p-button>
                            }
                            <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                                size="small" (click)="cancel()"></p-button>
                        </div>
                    </div>

                    <div class="flex align-items-center gap-3">
                        <label class="block label-required" style="font-weight: bold;">Required Field</label>

                        @if (iseditProduct) {
                        <p-button label="More" icon="pi pi-angle-down" iconPos="right" size="small"
                            (click)="moreMenu.toggle($event)"></p-button>
                        <p-menu #moreMenu [popup]="true" [model]="moreMenuItems"></p-menu>
                        }
                    </div>
                </div>
            </div>


        </div>

        <div class="grid mb">


            <div class="col">

                <div class="field text-left">
                    <label for="IsServiceType" class="label-required display">Type</label>
                    <div style="display: flex; gap: 1rem; align-items: center;">
                    <label>
                        <input type="radio" formControlName="IsServiceType"[value]="false"(change)="onTypeChange()" />Goods</label>

                    <label>
                        <input type="radio" formControlName="IsServiceType" [value]="true" (change)="onTypeChange()" /> Service
                    </label>
                    </div>

                    <!-- <div *ngIf="createProductForm.get('IsServiceType')?.invalid && createProductForm.get('IsServiceType')?.touched"
                        style="color: red;">
                        Please select a type (Goods or Service).
                    </div> -->
                    <small *ngIf="submitted && formControls.IsServiceType.errors" id="name-error" class="text-red-500">
                        Please select a type (Goods or Service).</small>
                </div>
                <div class="field text-left custom-widthPT">
                    <label for="producttypedropdown" class="label-required display">Product Type</label>
                    <p-autoComplete formControlName="producttypedropdown" [dropdown]="!iseditProduct"
                        (onSelect)="setProductType($event)" (completeMethod)="filterProductType($event)"
                        [suggestions]="filterproducttype" field="productTypeName" styleClass="w-full"
                        placeholder="Select Product Type" [forceSelection]="true" (keydown)="$event.preventDefault()"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductType.errors}">
                        <ng-template let-item pTemplate="item">
                            <span>{{item.productTypeCode}} - {{item.productTypeName}}</span>
                        </ng-template>
                    </p-autoComplete>
                    <small *ngIf="submitted && formControls.ProductType.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>


                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Product Code</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText placeholder="e.g P307" type="text" (blur)="checkProductCode()"
                            [readonly]="iseditProduct || !formControls.manualEntry.value" (keydown)="onKeydown($event)"
                            class="w-full" formControlName="ProductCode"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductCode.errors}" />
                        @if (!iseditProduct) { <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                                label="Manual Entry" value="true"></p-checkbox>
                        </div>
                        }
                    </div>
                    <small *ngIf="submitted && formControls.ProductCode.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>

                <div class="field text-left">
                    <label for="website" class="label-required display">Product Name</label>
                    <input pInputText placeholder="e.g Iphone 15 Pro" formControlName="ProductName"
                        (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductName.errors }"
                        class="w-full"/>
                    <small *ngIf="submitted && formControls.ProductName.errors" id="name-error"
                        class="text-red-500">Required
                        field.</small>
                </div>




            </div>

            <div class="col">
                <div class="flex align-items-center pd3">
                    <div class="flex align-items-center checkbox-container">
                        <p-checkbox label="Active" formControlName="isactive" [binary]="true"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.isactive.errors?.['requiredTrue'] }"></p-checkbox>
                        <small *ngIf="submitted && formControls.isactive.errors?.['requiredTrue']"
                            class="text-red-500">Required field.</small>
                    </div>

                    <div class="spacer1">
                        <p-checkbox label="Taxable" [readonly]="iseditProduct || !iseditProduct"
                            formControlName="IsTaxable" value="true" [binary]="true"></p-checkbox>
                    </div>

                    <div class="spacer1">
                        <p-checkbox label="Inventory" formControlName="IsInventory" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                </div>

                <div class="flex align-items-center">
                    <div class="flex align-items-center checkbox-container">
                        <p-checkbox label="Lot Controlled" formControlName="isLotTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>

                    <div class="spacer">
                        <p-checkbox label="Inventory By Location?" formControlName="isLocationTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>

                    <div class="spacer">
                        <p-checkbox label="Serial Tracking" formControlName="isSerialTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                </div><br>

                <div class="field-container" style="display: flex;gap: 5px;">
                    <div class="field text-left" style="flex: 1; margin-top: 0px;">
                        <label for="tags" class="bold-label">Product Size</label>
                        <input formControlName="ProductSize" pInputText placeholder="" (keydown)="onKeydown($event)"
                            class="w-full" />
                    </div>

                    <div class=" field text-left" style="flex: 1; margin-top: 0px;">
                        <label for="Weight">Weight</label>
                        <input pInputText formControlName="Weight" class="w-full" (keydown)="onKeydown($event)" />
                    </div>
                    <!--
                    <div class="calculation-container">
                        <fieldset class="field-setting">
                          <b><legend>Price Setting</legend></b>
                          <div class="radio-buttons-container">
                            <div class="flex align-items-center">
                              <p-radioButton value="Qty" inputId="CostCalculation1" formControlName="CostCalculation"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.CostCalculation.errors }"
                                class="radio-button"></p-radioButton>
                              <label for="CostCalculation1">By Quantity</label>

                              <div class="spacer"></div>
                              <p-radioButton value="Wgt" inputId="CostCalculation2" formControlName="CostCalculation"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.CostCalculation.errors }"
                                class="radio-button"></p-radioButton>
                              <label for="CostCalculation2">By Weight</label>
                            </div>
                            <small *ngIf="submitted && formControls.CostCalculation.errors" id="name-error" class="text-red-500"> Please select option for cost calculation.</small>
                          </div>
                        </fieldset>
                      </div> -->

                </div>

                <div class="field text-left" style="margin-top: 0px; ">
                    <label for="website">Product Specification / Grade</label>
                    <input pInputText formControlName="ProductSpecification" class="w-full"
                        (keydown)="onKeydown($event)" />
                </div>
                <div class="field text-left">
                    <label for="website">Product Description</label>
                    <input pInputText formControlName="ProductDescription" placeholder="e.g Powerfull iPhone innovation"
                        class="w-full" (keydown)="onKeydown($event)" />
                </div>
            </div>
            <div class="col">
                <div class="field text-left flex justify-content-center">
                    <input type="file" (change)="onFileSelected($event)" #fileInput style="display: none">

                    @if (previewImage) {
                    <div style="border: 2px solid; border-radius: 10px; position: relative; object-fit: fill;">
                        <p-image [src]="previewImage" alt="Image" width="150px" height="140" [preview]="true"></p-image>
                    </div>
                    } @else {
                    <label for="fileInput" style="cursor: pointer;" (click)="fileInput.click()">
                        <img src="./assets/upload-logo.jpg" width="100px" alt="Image"
                            style="border: 2px solid; border-radius: 10px; position: static;">
                    </label>
                    }
                    @if (previewImage) {
                    <div class="flex justify-content mt-2" style="align-items:center ;">
                        <p-button class="p-button-outlined ml-2 " severity="danger" icon="pi pi-trash" size="small"
                            (click)="deleteImage()"></p-button>
                    </div>
                    }
                </div>
            </div>
        </div>
        <br>
        <p-tabView [(activeIndex)]="activeIndex">
            <p-tabPanel header="General Information">

                <div class="grid">
                    <div class="col right-column">
                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="UOM" class="label-required display"> UOM</label>
                            <p-autoComplete formControlName="UOM" [dropdown]="true" (onSelect)="setUOM($event)"
                                [suggestions]="filteruom" (completeMethod)="filterUOM($event)" field="unitsofMeasure"
                                placeholder="Search UOM" styleClass="w-full" [forceSelection]="true"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.UnitsOfMeasure.value}"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <div class="field text-left custom-width">
                            <label for="tags" class="label-required display">Purchase Cost</label>
                            <input formControlName="StandardCost" type="number" (keydown)="onKeydown($event)" pInputText
                                placeholder="" class="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.StandardCost.errors}" />
                            <small *ngIf="submitted && formControls.StandardCost.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left custom-width">
                            <label for="tags" class="label-required display">Sales Price</label>
                            <input formControlName="SalesPrice" type="number" (keydown)="onKeydown($event)" pInputText
                                placeholder=""
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.SalesPrice.errors}"
                                class="w-full" />
                            <small *ngIf="submitted && formControls.SalesPrice.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <!-- <div class="field text-left mt-4 custom-width" *ngIf="!hide">
                            <label for="tags">Colour</label>
                             <p-autoComplete formControlName="ColorId" [dropdown]="true" (onSelect)="setColor($event)"
                                (completeMethod)="filterColor($event)" [suggestions]="filtercolor" field="colorName"
                                placeholder="Select color" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ColorId.errors}">
                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.colorName }}</span>
                                </ng-template>
                            </p-autoComplete>


                            <p-autoComplete formControlName="Color" [suggestions]="filteredColors" (completeMethod)="filterColors($event)"
                                field="colorName" [minLength]="1" placeholder="Select a color" [dropdown]="true" styleClass="w-full"
                                [forceSelection]="true"></p-autoComplete>
                        </div> -->

                        <div class="field-group"
                            style="display: flex; justify-content: space-between; gap: 10px; margin-top: 8px;">
                            <div class="field text-left mt-1" style="margin-top: 0;">
                                <label for="hsnCode" class="label-required display">HSN/SAC Code</label>
                                <div style="display: flex; align-items: center;">
                                    <input pInputText readonly (click)="getGSTList()" class="w-full p-inputtext-sm"
                                    formControlName="HSNCode" 
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.HSNCode.value}"
                                    (keydown)="onKeydown($event)" style="height: 28px;" />
                                    <div style="margin-left: 8px;">
                                        <p-button icon="pi pi-search" (click)="getGSTList()" [raised]="true" 
                                        [size]="'small'" severity="info"></p-button>
                                    </div>
                                </div>
                            </div>
                            <div class="field text-left mt-1" style="margin-top: 0;">
                                <label for="gstRate" class="label-required display">GST Rate (%)</label>
                                <div style="display: flex; align-items: center;">
                                    <input pInputText type="text" class="w-full p-inputtext-sm"
                                        formControlName="gstRate" readonly placeholder="GST Rate"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.gstRate.value}"
                                        (keydown)="onKeydown($event)" style="height: 28px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col left-column">
                        <!-- <div class="field text-left custom-width" *ngIf="hide">
                            <label for="UOM" class="label-required display">Stocking UOM</label>
                            <p-autoComplete formControlName="UOM" [dropdown]="true" (onSelect)="setUOM($event)"
                                [suggestions]="filteruom" (completeMethod)="filterUOM($event)" field="unitsofMeasure"
                                placeholder="Search UOM" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.UnitsOfMeasure.value}"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div> -->

                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="website" class="label-required display"> Product Group</label>
                            <p-autoComplete formControlName="ProductGroupName" [dropdown]="true"
                                [suggestions]="filterProductGroups" [forceSelection]="true"
                                (completeMethod)="filterProductGroup($event)" (onSelect)="setProductGroups($event)"
                                field="productGroupName" placeholder="Search Product Group" styleClass="w-full"
                                [ngClass]="{
                                                            'ng-invalid ng-dirty': submitted && !createProductForm.controls.ProductGroupName.value
                                                        }" (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.productGroupName }}</span>
                                </ng-template>
                            </p-autoComplete>

                            <!-- <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error" class="text-red-500">Required field.</small> -->
                        </div>
                        <div class="field text-left" *ngIf="!hide">
                            <label for="tags">Product Category</label>
                            <p-autoComplete formControlName="CategoryValue" [dropdown]="true" [forceSelection]="true"
                                (onSelect)="setCategory($event)" (completeMethod)="filtersCatagory($event)"
                                [suggestions]="filterCategorys" field="categoryName" placeholder="Select Category"
                                styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.CategoryValue.errors}">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.categoryCode}} - {{item.categoryName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <small *ngIf="submitted && formControls.CategoryValue.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left custom-width" *ngIf="!hide">
                            <label for="website"> Product SubCategory</label>

                            <p-autoComplete formControlName="SubCategoryName" [dropdown]="true" [forceSelection]="true"
                                (onSelect)="setProductSubCategory($event)" [suggestions]="filterCategorys"
                                (completeMethod)="filterSubCategory($event)" field="subCategoryName"
                                placeholder="Search SubCategory" styleClass="w-full"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.subCategoryName }}</span>
                                </ng-template>
                            </p-autoComplete>


                        </div>
                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="website">Purchase UOM</label>
                            <p-autoComplete formControlName="PurchasingUom" [dropdown]="true"
                                (onSelect)="setPurchasingUOM($event)" [suggestions]="filteruom"
                                (completeMethod)="filterUOM($event)" field="unitsofMeasure" placeholder="Search UOM"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                        </div>

                        <div class="field text-left custom-width" *ngIf="hide">
                            <label for="website">Selling UOM</label>
                            <p-autoComplete formControlName="SellingUom" [dropdown]="true"
                                (onSelect)="setSellingUOM($event)" [suggestions]="filteruom"
                                (completeMethod)="filterUOM($event)" field="unitsofMeasure" placeholder="Search UOM"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                                </ng-template>
                            </p-autoComplete>
                        </div>
                    </div>
                    <div class="col right-column">
                        <div class="field text-left mt-3">
                            <label for="Vendor">Primary Vendor</label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText formControlName="VendorName" readonly
                                    styleClass="w-full p-inputtext-sm" placeholder="Search"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.VendorName.errors}"
                                    (keydown.enter)="focusNextInput($event)" />
                                <button type="button" [disabled]="product.length > 0" pButton pRipple severity="info"
                                    icon="pi pi-search" (click)="getVendor()">
                                </button>
                            </div>
                        </div>
                        <div class="field text-left" *ngIf="!hide">
                            <label for="website">Vendor Product Code</label>
                            <input pInputText placeholder="e.g Iphone 15 Pro" formControlName="VendorProductCode"
                                (keydown)="onKeydown($event)" class="w-full" />
                        </div>
                        <div class="field text-left mt-4 custom-width" *ngIf="!hide">
                            <label for="tags">Standard Type</label>
                            <p-autoComplete formControlName="StandardType" [dropdown]="true"
                                (onSelect)="setstandardtype($event)" (completeMethod)="filterstandardtype($event)"
                                [suggestions]="filterStandardtype" field="StandardType" [forceSelection]="true"
                                placeholder="Select Standard Type" styleClass="w-full"
                                [ngClass]="{ 'ng-invalid ng-dirty': submitted && createProductForm.controls['StandardType'].invalid }">

                                <ng-template let-item pTemplate="item">
                                    <span>{{ item.StandardType }}</span>
                                </ng-template>
                            </p-autoComplete>

                        </div>
                        <div class="field text-left mt-4 custom-width" *ngIf="hide">
                            <label for="tags" class="label-required display">Product Category</label>
                            <p-autoComplete formControlName="CategoryValue" [dropdown]="true"
                                (onSelect)="setCategory($event)" (completeMethod)="filterCatagory($event)"
                                [suggestions]="filterCategorys" field="categoryName" placeholder="Select Category"
                                styleClass="w-full">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.categoryCode}} - {{item.categoryName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <!-- <small *ngIf="submitted && formControls.CategoryValue.errors" id="name-error"
                                class="text-red-500">Required field.</small> -->
                        </div>

                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Other Details">
                <div class="grid">
                    <div class="col">
                        <div class="field text-left">
                            <label for="website">Barcode</label>
                            <input pInputText placeholder="" formControlName="Barcode" class="w-full"
                                (keydown)="onKeydown($event)" />
                        </div>

                        <div class="field text-left" *ngIf="!hide">
                            <label for="website">MFG PartId</label>
                            <input pInputText formControlName="mkfpartid" class="w-full"
                                (keydown)="onKeydown($event)" />
                        </div>

                    </div>
                    <div class="col">
                        <div class="field text-left" *ngIf="!hide">
                            <label for="website">MAKE</label>
                            <input pInputText formControlName="make" class="w-full" (keydown)="onKeydown($event)" />
                        </div>

                        <div class="field text-left" *ngIf="!hide">
                            <label for="website">Remark</label>
                            <input pInputText formControlName="productcomment" class="w-full"
                                (keydown)="onKeydown($event)" />
                        </div>

                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </form>
</p-card>

<p-toast></p-toast>